export const WaterMarkLogo: React.FC<React.SVGProps<SVGSVGElement>> = ({ className, ...rest }) => (
    <svg
        className={className}
        width="1346"
        height="1510"
        viewBox="0 0 1346 1510"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            d="M986.057 0C1219.01 0.000103323 1345.53 94.4923 1345.54 333.738V1168.08C1345.54 1405.32 1215 1509.87 984.048 1509.87H365.504C271.116 1509.87 176.727 1499.81 104.43 1435.48C30.124 1371.14 1.59444e-05 1264.59 0 1170.1V343.791C0 245.278 32.1321 144.755 106.437 76.3984C178.735 12.0633 269.107 1.37342e-05 363.495 0H986.057ZM218.902 649.385V1107.77C218.902 1160.04 230.953 1212.32 269.109 1250.52C309.274 1290.72 361.489 1290.73 415.712 1290.73H933.844C1062.37 1290.73 1128.64 1250.52 1126.64 1113.8V649.385H218.902ZM415.711 219.144C279.149 219.144 218.901 267.396 218.901 408.129V430.244H1126.63V408.129C1126.63 269.406 1068.4 219.144 931.834 219.144H415.711Z"
            fill="currentColor"
        />
    </svg>
);

export const WaterMarkPercent: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className,
    ...rest
}) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="656"
        height="657"
        viewBox="0 0 656 657"
        fill="none"
        {...rest}
    >
        <path
            clip-rule="evenodd"
            d="M253.643 215.761V124.199C253.643 46.2345 197.479 0 126.821 0C56.1638 0 0 46.2345 0 124.199V215.761C0 293.725 56.1638 339.053 126.821 339.053C197.479 339.053 253.643 293.725 253.643 215.761ZM655.612 532.391V441.073C655.612 363.317 599.448 317.205 528.79 317.205C458.133 317.205 401.969 363.317 401.969 441.073V532.391C401.969 610.147 458.133 656.259 528.79 656.259C599.448 656.259 655.612 610.147 655.612 532.391ZM442.679 5.41755L516.079 5.41755L212.51 650.74L138.203 650.74L442.679 5.41755ZM585.191 532.024C585.191 572.471 567.251 596.74 528.682 596.74C490.112 596.74 472.173 573.37 472.173 532.024L472.173 446.635C472.173 405.289 490.112 381.92 528.682 381.92C567.251 381.92 585.191 406.188 585.191 446.635V532.024ZM125.818 274.434C164.388 274.434 182.327 250.967 182.327 210.349L182.327 124.602C182.327 83.9847 164.388 59.6143 125.818 59.6143C87.2488 59.6143 69.3095 83.0821 69.3095 124.602V210.349C69.3095 251.869 87.2488 274.434 125.818 274.434Z"
            fill="currentColor"
            fill-rule="evenOdd"
        />
    </svg>
);
